import { Status } from "@/models/activity.model";

const activities = [
  {
    id: "abcde",
    title: "Atividade de Solid 1",
    score: 10,
    scoreRange: 100,
    status: {
      class: "bg-h-success-100 text-h-success-500 px-3 py-2 rounded-md",
      value: Status.FEEDBACK,
      text: "Corrigido",
      icon: "bi-check-circle-fill",
    },
  },
  {
    id: "abcde",
    title: "Atividade de Solid 1",
    score: 10,
    scoreRange: 100,
    status: {
      class: "bg-h-success-100 text-h-success-500 px-3 py-2 rounded-md",
      value: Status.FEEDBACK,
      text: "Corrigido",
      icon: "bi-check-circle-fill",
    },
  },
  {
    id: "abcde",
    title: "Atividade de Solid 1",
    score: 10,
    scoreRange: 100,
    status: {
      class: "bg-h-primary-100 text-h-primary-500 px-3 py-2 rounded-md",
      value: Status.OPEN,
      text: "Aguardando Correção",
      icon: "io-timer-sharp",
    },
  },
  {
    id: "abcde",
    title: "Atividade de Solid 1",
    score: 10,
    scoreRange: 100,
    status: {
      class: "bg-h-warning-100 text-h-warning-500 px-3 py-2 rounded-md",
      value: Status.CLOSED,
      text: "Não enviado",
      icon: "io-timer-sharp",
    },
  },
  {
    id: "abcde",
    title: "Atividade de Solid 1",
    score: 10,
    scoreRange: 100,
    status: {
      class: "bg-h-success-100 text-h-success-500 px-3 py-2 rounded-md",
      value: Status.FEEDBACK,
      text: "Corrigido",
      icon: "bi-check-circle-fill",
    },
  },
];


export {activities}